"use strict";

var objToString = Object.prototype.toString
  , id = objToString.call(
	(function () {
		return arguments;
	})()
);

module.exports = function (value) {
	return objToString.call(value) === id;
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/function/is-arguments.js
// module id = 730
// module chunks = 0